export default (text) => {
    let date = text.split("T")[0];
    let time = text.split("T")[1];
    let dt = new Date(date.split("-")[0], (date.split("-")[1] === 0 ? 0 : (date.split("-")[1] - 1)), date.split("-")[2], time.split(":")[0], time.split(":")[1], 0);
    return dt;
}